<app-table
    [items]="store.items()"
    [columns]="columns"
    [tableTitle]="(prefix + 'title') | translate"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
>
    <ng-template pTemplate="type" let-data="data">
        {{ (prefix + 'type.' + data) | translate }}
    </ng-template>

    <ng-template pTemplate="entryType" let-data="data">
        {{ (prefix + 'entryType.' + data) | translate }}
    </ng-template>

    <ng-template pTemplate="accountId" let-item="item">
        @if (item.account) {
            <div>{{ madoAccountToDropdownOptionString(item.account) }}</div>
        }
    </ng-template>
</app-table>
